(() => {
  function init(section) {
    const leftSlides = Array.from(section.querySelectorAll(".sbs__slide--left"));
    const rightSlides = Array.from(section.querySelectorAll(".sbs__slide--right"));
    const dots = Array.from(section.querySelectorAll(".sbs__dot"));

    if (!leftSlides.length || !rightSlides.length) return;

    const autoplay = section.dataset.autoplay === "true";
    const delaySec = Number(section.dataset.delay || "3");
    const pauseOnHover = section.dataset.pauseOnHover === "true";
    const delay = Math.max(2, delaySec) * 1000;

    let index = 0;
    let timer = null;
    let hovering = false;

    function setActive(i) {
      index = (i + leftSlides.length) % leftSlides.length;

      leftSlides.forEach((el, idx) => el.classList.toggle("is-active", idx === index));
      rightSlides.forEach((el, idx) => el.classList.toggle("is-active", idx === index));

      dots.forEach((btn, idx) => {
        const active = idx === index;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-current", active ? "true" : "false");
      });
    }

    function next() { setActive(index + 1); }
    function prev() { setActive(index - 1); }

    function start() {
      stop();
      if (!autoplay || leftSlides.length < 2) return;
      timer = window.setInterval(() => {
        if (pauseOnHover && hovering) return;
        next();
      }, delay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    // dots
    dots.forEach((btn) => {
      btn.addEventListener("click", () => {
        const i = Number(btn.dataset.index || "0");
        setActive(i);
        start();
      });
    });

    // arrows (bind directly, not delegation)
    const prevBtns = Array.from(section.querySelectorAll(".sbs__arrow--prev"));
    const nextBtns = Array.from(section.querySelectorAll(".sbs__arrow--next"));

    prevBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        prev();
        start();
      });
    });

    nextBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        next();
        start();
      });
    });

    // Hover pause
    if (pauseOnHover) {
      section.addEventListener("mouseenter", () => { hovering = true; });
      section.addEventListener("mouseleave", () => { hovering = false; });
    }

    setActive(0);
    start();

    section.__sbsDestroy = stop;
  }

  function initAll() {
    document.querySelectorAll(".sbs[data-section-id]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target.querySelector(".sbs[data-section-id]");
    if (section) init(section);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const section = e.target.querySelector(".sbs[data-section-id]");
    if (section && section.__sbsDestroy) section.__sbsDestroy();
  });
})();
